<div class="button-wrapper">
  <button type="button">
    <ng-content></ng-content>
  </button>
</div>
